module.exports = __webpack_public_path__ + "static/media/gen_abs.db5bce13.JPG";